module.exports = __webpack_public_path__ + "static/027.thumb-fa2cd71adc814a800e00874cd8ca7e46.jpg";